<template>
  <div class="w-full flex flex-wrap items-center pl-12 pb-5 h-28">
    <content-loader
      :width="600"
      :height="600"
      :speed="1"
      :primaryColor="primaryColor"
      :secondaryColor="secondaryColor"
    >
      <rect x="46" y="18" rx="3" ry="3" width="178" height="6" /> 
      <rect x="5" y="17" rx="0" ry="0" width="29" height="27" /> 
      <rect x="46" y="32" rx="3" ry="3" width="178" height="6" />
    </content-loader>
  </div>
</template>

<script>
  import { ContentLoader } from "vue-content-loader";
  
  export default {
    name: 'RowSkeleton',

    props: {
      primaryColor: {
        type: String,
        default: '#F1F1F1',
      },

      secondaryColor: {
        type: String,
        default: '#FAFAFA',
      },
    },

    components: {
      ContentLoader,
    },
  }
</script>
